module.exports = __webpack_public_path__ + "static/media/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver-norming.b9673459.mp3";